import React from "react";
import tiktok from "../assets/images/tictok.png";
import { FacebookIcon } from "react-share";

const SocialLinks = ({ alt }) => {
  return (
    <div className="socialLinks">
      <a
        href="https://www.facebook.com/chaol.carington"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FacebookIcon size={33} />
      </a>

      <a
        href="https://www.tiktok.com/@chaol.carington.l?_r=1&_t=ZS-942wsdaX0Ph"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={tiktok} alt="TikTok" />
      </a>

      {/* Instagram link not yet provided */}
      {/* 
      <a
        href=""
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={instagram} alt="Instagram" />
      </a> */}
    </div>
  );
};

export default SocialLinks;
